import { render } from "./App.vue?vue&type=template&id=e03112ee"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=e03112ee&lang=scss"
script.render = render

export default script